import styled, { css } from 'styled-components';
import { variant, grid, GridProps } from 'styled-system';

import { ThemeUtilities } from '../../../theme';
import { Size, ColorVariant, IconColorVariant } from './types';

export const Container = styled.div<
  { size: Size; colorVariant: ColorVariant } & GridProps
>`
  display: inline-grid;
  grid-template-columns: repeat(2, auto);
  align-items: center;
  ${grid};

  ${(props) =>
    variant(ThemeUtilities.getComponentVariant(props, 'ToastMessage', 'size'))};

  ${(props) =>
    variant(
      ThemeUtilities.getComponentVariant(props, 'ToastMessage', 'colorVariant')
    )};

  ${css((props) =>
    ThemeUtilities.getComponentCSSOverrides(props, 'ToastMessage')
  )};
`;

export const IconContainer = styled.div<{
  iconColor: IconColorVariant;
}>`
  ${(props) =>
    variant(
      ThemeUtilities.getComponentVariant(props, 'ToastMessage', 'iconColor')
    )};
`;
